<template>
  <div class="tss-aboutUs">
    <menuBox :step="2"></menuBox>
    <div class="tss-aboutusbox">
      <div class="title">
        <p>สินค้าและบริการ</p>
        <span>เรามุ่งมั่นที่จะให้บริการลูกค้าด้วยโซลูชันผลิตภัณฑ์โลหะที่ปรับแต่งได้หลากหลายแก่ลูกค้าผ่านเทคโนโลยีการประมวลผลโลหะขั้นสูงและแนวคิดการออกแบบเชิงนวัตกรรม
          ตั้งแต่การพัฒนาต้นแบบไปจนถึงการผลิตจำนวนมาก
          เพื่อให้มั่นใจว่าสอดคล้องกับมาตรฐานคุณภาพสูงสุดและข้อกำหนดทางเทคนิคในทุกขั้นตอน</span>
      </div>
    </div>
    <div class="digital">
      <div class="title">ตรวจสอบทุกระดับ</div>
      <div class="text">ในงานฝีมือของเรา ความแม่นยำและความน่าเชื่อถือเป็นค่านิยมหลักในทุกผลิตภัณฑ์
        ด้วยการออกแบบทางวิศวกรรมที่ยอดเยี่ยมและเทคโนโลยีการผลิตที่ยอดเยี่ยม
        เรามอบชิ้นส่วนและส่วนประกอบโลหะประสิทธิภาพสูงให้กับลูกค้าในอุตสาหกรรมต่างๆ
        เพื่อให้มั่นใจถึงความเสถียรและความทนทานในสภาพแวดล้อมการใช้งานที่หลากหลาย
      </div>
      <div class="lineBox">
        <div class="item">
          <img src="../assets/digital1.png" alt="">
          <p>การตัด:</p>
          <span>การตัดที่แม่นยำเป็นก้าวแรกสู่การออกแบบที่สมบูรณ์แบบ
            เราใช้เทคโนโลยีการตัดขั้นสูงและอุปกรณ์ที่มีความแม่นยำเพื่อให้แน่ใจว่าวัสดุโลหะทุกชนิดสามารถตัดได้อย่างแม่นยำตามความต้องการของคุณ
            ไม่ว่าจะเป็นรูปทรงเรขาคณิตที่เรียบง่ายหรือโปรไฟล์โค้งที่ซับซ้อน ก็สามารถดำเนินการได้อย่างถูกต้อง</span>
        </div>
        <div class="item">
          <img src="../assets/digital2.png" alt="">
          <p>การผลิตเครื่องจักร:</p>
          <span>พลังการผลิตเครื่องจักรสร้างคุณภาพที่ยอดเยี่ยม
            เรามีอุปกรณ์เครื่องจักรกลที่มีประสิทธิภาพและสายการผลิตอัตโนมัติที่หลากหลายซึ่งสามารถผลิตผลิตภัณฑ์โลหะตามข้อกำหนดต่างๆ
            ได้อย่างรวดเร็วและแม่นยำ เพื่อให้มั่นใจในคุณภาพและผลผลิตในระดับที่เหมาะสมที่สุด</span>
        </div>
        <div class="item">
          <img src="../assets/digital3.png" alt="">
          <p>ตำแหน่ง:</p>
          <span>วางอย่างระมัดระวังเพื่อให้แน่ใจว่าทุกส่วนประกอบมีการประสานงานอย่างสมบูรณ์แบบ
            เรามุ่งเน้นที่งานประกอบและประกอบ
            เพื่อให้มั่นใจว่าการติดตั้งและการดีบักส่วนประกอบแต่ละชิ้นผ่านฝีมือการผลิตที่มีความแม่นยำและการควบคุมคุณภาพอย่างเข้มงวดเพื่อให้ได้ประสิทธิภาพที่มีประสิทธิภาพและความน่าเชื่อถือในระยะยาวของผลิตภัณฑ์ขั้นสุดท้าย</span>
        </div>
        <div class="item">
          <img src="../assets/digital4.png" alt="">
          <p>พรุน:</p>
          <span>ตัดแต่งอย่างประณีตและแกะสลักให้ละเอียดสมบูรณ์แบบ
            ช่างเทคนิคและผู้ปฏิบัติงานของเราใช้เครื่องมือและเทคนิคการตัดแต่งอย่างแม่นยำ
            ทำงานอย่างระมัดระวังบนขอบและรายละเอียดของงานโลหะแต่ละชิ้นเพื่อให้แน่ใจว่ามีรูปลักษณ์และฟังก์ชันการทำงานที่ผสมผสานกันอย่างลงตัว</span>
        </div>
      </div>
      <div class="lineBox">
        <div class="item">
          <img src="../assets/digital5.png" alt="">
          <p>ขัด:</p>
          <span>ขัดอย่างระมัดระวังเพื่อให้ได้พื้นผิวที่เรียบเนียน
            เราใช้อุปกรณ์บดขั้นสูงและเทคโนโลยีระดับมืออาชีพในการบดผลิตภัณฑ์โลหะแต่ละอย่างอย่างระมัดระวัง
            เพื่อให้พื้นผิวเรียบและสะอาด แสดงพื้นผิวที่หรูหราและเอฟเฟกต์ภาพที่ยอดเยี่ยม</span>
        </div>
        <div class="item">
          <img src="../assets/digital6.png" alt="">
          <p>การวัด:</p>
          <span>การวัดที่แม่นยำเพื่อให้แน่ใจว่าทุกขนาดตรงตามมาตรฐาน ด้วยเครื่องมือและอุปกรณ์วัดขั้นสูง
            เราวัดและตรวจสอบอย่างเข้มงวดตามแบบวิศวกรรมและมาตรฐานคุณภาพเพื่อให้แน่ใจว่าแต่ละมิติมีความแม่นยำและตรงตามมาตรฐานที่สมบูรณ์แบบตามที่ลูกค้าของเราคาดหวัง</span>
        </div>
        <div class="item">
          <img src="../assets/digital7.png" alt="">
          <p>เชื้อรา:</p>
          <span>การหล่อที่แม่นยำ คุณภาพการสร้างรูปร่าง และนวัตกรรม
            กระบวนการหล่อของเราผสมผสานงานฝีมือแบบดั้งเดิมเข้ากับเทคโนโลยีสมัยใหม่
            เราหล่อผลิตภัณฑ์โลหะที่มีรูปร่างที่ซับซ้อนและประสิทธิภาพที่ยอดเยี่ยมเพื่อตอบสนองความต้องการของตลาดที่หลากหลายผ่านแม่พิมพ์ที่มีความแม่นยำและการรักษาที่อุณหภูมิสูง</span>
        </div>
        <div class="item">
          <img src="../assets/digital8.png" alt="">
          <p>การตรวจสอบคุณภาพ:</p>
          <span>การตรวจสอบคุณภาพอย่างเข้มงวดทำให้มั่นใจในคุณภาพที่ดีเยี่ยมของแต่ละผลิตภัณฑ์
            ทีมตรวจสอบคุณภาพของเรามีหน้าที่รับผิดชอบในการใช้ขั้นตอนและมาตรฐานการทดสอบที่เข้มงวดเพื่อให้แน่ใจว่าทุกขั้นตอนการผลิตเป็นไปตามข้อกำหนดด้านคุณภาพ
            จึงทำให้ผลิตภัณฑ์มีประสิทธิภาพที่เชื่อถือได้และอายุการใช้งานยาวนาน</span>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "projects" });
    }
  },
};
</script>
<style lang="less" scoped>
.tss-aboutusbox {
  background-image: url(../assets/aboutUs.png);
  width: 100%;
  height: 420px;
  padding: 200px 360px 0;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;

  .title {
    float: right;
    width: 600px;
    text-align: right;

    p {
      margin-bottom: 20px;
      font-size: 56px;
      color: #FFFFFF;
      line-height: 67px;
    }

    span {
      font-size: 20px;
      color: #FFFFFF;
      line-height: 24px;
    }
  }
}

.digital {
  padding: 100px 360px;

  .title {
    margin-bottom: 24px;
    font-size: 40px;
    color: #333333;
    line-height: 48px;
  }

  .text {
    margin-bottom: 48px;
    font-size: 16px;
    color: #333333;
    line-height: 28px;
  }

  .lineBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 64px;

    .item {
      width: 280px;
      margin-right: 26px;

      img {
        margin-bottom: 24px;
        width: 280px;
      }

      p {
        margin-bottom: 10px;
        font-size: 24px;
        color: #333333;
        line-height: 29px;
      }

      span {
        font-size: 16px;
        color: #999999;
        line-height: 28px;
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}
</style>
